import { render, staticRenderFns } from "./CashToReceive.vue?vue&type=template&id=37cf52b2&scoped=true&"
import script from "./CashToReceive.vue?vue&type=script&lang=js&"
export * from "./CashToReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf52b2",
  null
  
)

export default component.exports